module.exports = {"532503101":"文澜镇","532503102":"草坝镇","532503103":"雨过铺镇","532503104":"新安所镇","532503105":"芷村镇","532503106":"鸣鹫镇","532503107":"冷泉镇","532503201":"期路白苗族乡","532503202":"老寨苗族乡","532503203":"水田乡","532503204":"西北勒乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532503.json
// module id = 2435
// module chunks = 0